import { Component, HostListener, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import {
  CollectionRoomType,
  ICustomApp,
  IEventGeneralSettings,
  ILogin,
  INavigationLink,
  IRegistrationStandard,
  LoginType,
  RegistrationType
} from '@sv/interfaces';
import { InitAppService } from 'src/app/_services/init-app.service';
import { AttendeesService } from 'src/app/_services/_auth/attendees.service';
import { AuthService } from 'src/app/_services/_auth/auth.service';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';
import { NavigationService } from 'src/app/_services/_content/navigation.service';
import { RegistrationService } from 'src/app/_services/_content/registration.service';
import { CustomAppService } from '../../../_services/_content/customApp.service';
import { AuthSupportDialogComponent } from '../auth-support-dialog/auth-support-dialog.component';
import { FogotPasswordDialogComponent } from '../fogot-password-dialog/fogot-password-dialog.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  customApp: ICustomApp;
  login: ILogin;
  invalid = false;
  enabledEmail = false;
  registrationOn = false;
  links: INavigationLink[];
  routingUrl: string;
  collectionRoomId: string;
  collectionRoomType: CollectionRoomType;

  hidePw = true;
  notActivated = false;

  isLoading = true;
  mobile = false;

  constructor(
    private router: Router,
    private customAppService: CustomAppService,
    private ticketcodeAuthService: TicketcodeAuthService,
    private initAppService: InitAppService,
    private registrationServce: RegistrationService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private attendeesService: AttendeesService,
    private authService: AuthService,
    private snackBar: MatSnackBar
  ) {}
  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
  }

  async ngOnInit(): Promise<void> {
    this.mobile = document.documentElement.clientWidth < 699;
    this.customAppService.getCustomAppListener().subscribe((customApp) => {
      this.customApp = customApp;
      this.login = this.customApp.login as ILogin;

      if (!this.login.enabled && !this.router.url.startsWith('/av63wraph3bdva3r8')) {
        this.router.navigate(['/']);
        return;
      }

      this.route.queryParams.subscribe(async (params) => {
        const ticketcode = params.ticketcode;
        const tradefairId = params.tradefairId;
        //collection sub pages
        const keynoteId = params.keynoteId;
        const workshopId = params.workshopId;
        const receptionId = params.receptionId;
        const networkingId = params.networkingId;
        const collectionId = params.collectionId;
        //collection sub pages

        const boothId = params.boothId;
        const linkId = params.linkId;

        const email = params.email;
        const firstName = params.firstName;
        const lastName = params.lastName;

        const preview = params.preview;
        const boothOverview = params.boothOverview;

        const token = params.token;

        if (preview) {
          this.ticketcodeAuthService.logout();
          return;
        }

        if (token) {
          const data = this.authService.decodedToken(token);
          const activation = await this.attendeesService.updateAttendeeActivation(data.email, this.customApp.eventId, token);
          if (activation) {
            this.snackBar.open(`Sie haben Ihre Email erfolgreich aktiviert und können sich nun einloggen.`, 'Schließen', {
              duration: 3000
            });
          } else {
            this.snackBar.open(`Der Account konnte nicht aktiviert werden.`, 'Schließen', {
              duration: 3000
            });
          }
          return;
        }

        if (ticketcode && ticketcode !== 'undefined') {
          await this.onLogin(undefined, ticketcode);
          if (!linkId) {
            this.router.navigate(['/']);
            return;
          }
          const navigation = await this.navigationService.getCompleteNavigationById(this.customApp.navigation as string);
          this.links = navigation.links as INavigationLink[];
          this.links.forEach((link) => {
            if (link._id === linkId) {
              this.routingUrl = link.route;
              if (tradefairId) {
                this.routingUrl += `/${tradefairId}`;
                this.collectionRoomId = tradefairId;
                this.collectionRoomType = CollectionRoomType.EXPO;
              } else if (keynoteId) {
                this.routingUrl += `/${keynoteId}`;
                this.collectionRoomId = keynoteId;
                this.collectionRoomType = CollectionRoomType.KEYNOTE;
              } else if (networkingId) {
                this.routingUrl += `/${networkingId}`;
                this.collectionRoomId = networkingId;
                this.collectionRoomType = CollectionRoomType.NETWORKING;
              } else if (workshopId) {
                this.routingUrl += `/${workshopId}`;
                this.collectionRoomId = workshopId;
                this.collectionRoomType = CollectionRoomType.WORKSHOP;
              } else if (receptionId) {
                this.routingUrl += `/${receptionId}`;
                this.collectionRoomId = receptionId;
                this.collectionRoomType = CollectionRoomType.RECEPTION;
              } else if (collectionId) {
                this.routingUrl += `/${collectionId}`;
                this.collectionRoomId = collectionId;
                this.collectionRoomType = CollectionRoomType.COLLECTION;
              }
              if (boothId) {
                this.routingUrl += `?boothId=${boothId}`;
                this.routingUrl = boothOverview ? this.routingUrl + '&boothOverview=true' : this.routingUrl;
              }
              this.addRoutes(link);
            }
          });
        }
        if (email && firstName && lastName) {
          await this.emendoLogin(email, firstName, lastName);
        }
      });
    });

    if (typeof this.customApp.registration === 'string') {
      this.customApp.registration = await this.registrationServce.getRegistrationById(this.customApp.registration);
    }
    if (this.customApp.registration.type === RegistrationType.STANDARD) {
      const settings = this.customApp.registration.settings as IRegistrationStandard;
      if (this.customApp.registration.enabled && settings.enabledEmail) {
        this.enabledEmail = true;
      }
    } else if (
      this.customApp.registration.type === RegistrationType.EVENTBRITE ||
      this.customApp.registration.type === RegistrationType.EMAILPW
    ) {
      this.registrationOn = true;
    }

    if (this.ticketcodeAuthService.getIsAuthenticted() && this.router.url !== '/av63wraph3bdva3r8') {
      if ((this.customApp.generalSettings as IEventGeneralSettings).enableLP) {
        // the first 7 are always the same like login etc, 8th is the first module. See app-routing for full list of non-dynamic routes
        this.router.navigate([this.router.config[8].path]);
      } else {
        this.router.navigate(['/']);
      }
    }

    this.isLoading = false;
  }

  addRoutes(link: INavigationLink) {
    this.initAppService.prepoulateContent(link, this.collectionRoomId, this.collectionRoomType);
    this.initAppService.addRoutes(this.links);
    this.router.navigateByUrl(this.routingUrl, { queryParamsHandling: 'preserve' });
  }

  async emendoLogin(email: string, firstName: string, lastName: string) {
    try {
      // TEST http://localhost:4201/login?email=eddy.emendo@gmail.com&firstName=Vorname_Test1&lastName=Nachname_Test1
      await this.ticketcodeAuthService.emendoLogin(email, firstName, lastName, this.customApp.eventId);
      this.initAppService.loadRemainingData(true);
      this.router.navigate(['/']);
    } catch (error) {
      console.log(error);
      this.router.navigate(['login/error']);
    }
  }

  async onLogin(form: NgForm, code?: string) {
    if (form && form.invalid && !code) {
      return;
    }
    this.notActivated = false;

    let ticketcode;
    if (form) {
      ticketcode = form.value.ticketcode.toString().trim();
    } else {
      ticketcode = code.trim();
    }

    if (form && this.login.type && this.login.type === LoginType.EMAILPW) {
      const email = form.value.email.toString().trim();
      try {
        await this.ticketcodeAuthService.promiseLogin(ticketcode, this.customApp.eventId, email);
        if (!code) {
          this.initAppService.loadRemainingData(true);
        }
      } catch (error) {
        if (error.error.message === 'invalid password or email') {
          this.invalid = true;
        } else if (error.error.message === 'account not activated') {
          this.notActivated = true;
        } else {
          console.log(error);
          this.invalid = true;
        }
        return;
      }
    } else {
      try {
        await this.ticketcodeAuthService.promiseLogin(ticketcode, this.customApp.eventId);
        if (!code) {
          this.initAppService.loadRemainingData(true);
        }
      } catch (error) {
        if (error.error.message === 'invalid ticketcode: ticketcode does not exist') {
          this.invalid = true;
        } else {
          console.log(error);
          this.invalid = true;
        }
        return;
      }
    }
  }

  openSupport() {
    const data = {
      captionSupport: this.login.captionSupport,
      support: this.login.support
    };
    this.dialog.open(AuthSupportDialogComponent, { data });
  }

  onForgotPassword() {
    if (this.mobile) {
      const ref = this.dialog.open(FogotPasswordDialogComponent, { width: '100%', height: '100%', maxHeight: '100vh', maxWidth: '100vw' });
      ref.afterClosed().toPromise();
    } else {
      const ref = this.dialog.open(FogotPasswordDialogComponent);
      ref.afterClosed().toPromise();
    }
  }
}
